import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GithubAuthData } from '@jukebox/common';
import { filter, lastValueFrom, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GithubAuthDataService {
  private githubAuthData: Record<string, GithubAuthData> = {};

  constructor(private http: HttpClient) {}

  public getGithubAuthDataForDomain(domain: string): GithubAuthData {
    return this.githubAuthData[domain];
  }

  public async removeGithubAuthData() {
    if (Object.entries(this.githubAuthData).length !== 0) {
      await this.deleteGithubTokens();
      this.githubAuthData = {};
    }
  }

  public async fetchTokenFromGithubAndStoreIt(
    code: string,
    domain: string,
  ): Promise<GithubAuthData> {
    return await lastValueFrom(
      this.http
        .post<GithubAuthData>(
          `rest/github-token?code=${code}&domain=${domain}&state=`,
          {},
        )
        .pipe(
          tap(
            (githubAuthData) => (this.githubAuthData[domain] = githubAuthData),
          ),
        ),
    );
  }

  public async deleteGithubTokens() {
    await lastValueFrom(this.http.delete<void>('rest/github-token'));
  }

  public async readGithubAuthData() {
    await lastValueFrom(
      this.http.get<Record<string, GithubAuthData>>('rest/github-token').pipe(
        filter((result) => !!result),
        tap((result) => {
          this.githubAuthData = result;
        }),
      ),
    );
  }
}
